// extracted by mini-css-extract-plugin
module.exports = {"bar":"FilesFilterBar_bar__j04to","chipWrap":"FilesFilterBar_chipWrap__ohJfn","chipTrigger":"FilesFilterBar_chipTrigger__t_WXy"};